import React from "react";

export type PageSize = { width: number; height: number };

// This Context allows child components to have access to the actual page size,
// as useWindowDimensions on desktop will give the size of the entire page
// rather than just the mobile-sized part. These default sizes are arbitrary.
// This value is set by the PageSizeContext.Provider in App.tsx.
export const PageSizeContext = React.createContext({ width: 400, height: 500 });
